export default __webpack_public_path__ + "static/media/Logo.0529445b.svg";